import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const logout = async () => {
  return httpRequest.get("/2fa/auth/logout");
};
